import axios from "axios";
import { apiUrl } from "../../config";

export const addModelNumberMaster = (acc) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${apiUrl}/api/model-number-master/create`,
      acc
    );

    return {
      response,
    };
  } catch (error) {}
};

export const getAllModelNumberMasterLength = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/model-number-master/getAllModelNumberMasterLength`
    );
    console.log("%%%111%%%", response.data.results[0].tot);
    return { response };
  } catch (error) {}
};

export const getAllModelNumberMaster =
  (offset, row_count) => async (dispatch) => {
    try {
      const response = await axios.get(
        `${apiUrl}/api/model-number-master/getAllModelNumberMaster/${offset}/${row_count}`
      );
      dispatch({
        type: "GET_MODELNUMBER_SUCCESS",
        payload: response.data.results,
      });
    } catch (error) {}
  };

export const updateModelNumberMaster = (pur) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${apiUrl}/api/model-number-master/update`,
      pur
    );
    return { response };
    // window.location.reload()
  } catch (error) {
    alert("Something Went Wrong");
    console.log(error);
  }
};

export const deleteModelNumberMaster = (accid) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${apiUrl}/api/model-number-master/delete`,
      {
        accid,
      }
    );
    return { response };
    // window.location.reload()
  } catch (error) {
    alert("Something Went Wrong");
    console.log(error);
  }
};

export const searchModelNumberMaster = (val) => async (dispatch) => {
  const data = { id: val };
  try {
    const response = await axios.post(
      `${apiUrl}/api/model-number-master/search`,
      data
    );
    return { response };
    // window.location.reload()
  } catch (error) {
    return { error };
  }
};

export const getAllModelNumberNames = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/model-number-master/getallModelNumberNames`
    );
    //console.log('##123456##',response.data.results)
    dispatch({ type: "GET_MNNAME_SUCCESS", payload: response.data.results });
  } catch (error) {}
};
